import * as Yup from "yup";
import { StringValidation, DropdownValidation } from "./PlanSchema";

export const MatrixSettingsSchema = Yup.object().shape({
  name: StringValidation.label("Name"),
  // min_score: StringValidation.label("Min Score"),
  // max_score: StringValidation.label("Max Score"),
});
